import useRestApiCall from "../http.interceptor";
import axios from "axios";

const useGetIpAddress = () => {

    

    const ipAddressPayload  ={
        method: "GET",
        baseURL: "https://geolocation-db.com/json/",
    }


    const getIpAddress = async () => {
        try {
            const res = await axios.get("https://api.ipify.org/?format=json");
            if(res?.data) {
                return res.data;
            }
        }
        catch(error) {

        }


    }

    return { getIpAddress };

}

export default useGetIpAddress;
